import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/referral/rules/ReferralRulesClient.tsx");
